import { APIErrorResponse } from '@arc-publishing/sdk-subs-core/lib/utils/APIErrorResponse';
import JSONResponseHandler from '@arc-publishing/sdk-subs-core/lib/utils/JSONResponseHandler';

import { headers } from './constants';
import { getValidURL } from './utils';
import AMP from './amp';

/**
 * @param ampReaderId
 *
 * @returns __Promise__ When the AMP reader ID is associated to an account in Arc, it returns true
 * <details>
 *  <summary>
 *    On success (resolves)
 *  </summary>
 *
 * true
 *
 * </details>
 *
 * <details>
 *  <summary>
 *    On error (throws)
 *  </summary>
 *
 * ```
 *  See documentation for corresponding error codes:
 *  https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-sales.json#SwG_Interaction/addAmpReaderId
 * ```
 * </details>
 */

export interface SaveAmpReaderIdResponse {
  message?: string;
}

export function isAMPReaderSaved(
  x: APIErrorResponse | SaveAmpReaderIdResponse
): x is SaveAmpReaderIdResponse {
  return !!((<SaveAmpReaderIdResponse>x).message === 'ok');
}

export default function saveAMPReaderID(ampReaderId: string): Promise<APIErrorResponse | boolean> {
  const url = typeof window !== 'undefined' ? getValidURL(AMP.apiOrigin) : AMP.apiOrigin;

  return AMP._Identity
    .heartbeat()
    .then(() =>
      fetch(`${url}/sales/public/v1/amp/add`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${AMP._Identity.userIdentity.accessToken}`,
          ...headers
        },
        body: JSON.stringify({
          ampReaderId
        })
      })
    )
    .then(JSONResponseHandler)
    .then((json: APIErrorResponse | SaveAmpReaderIdResponse) => {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (isAMPReaderSaved(json)) {
            resolve(true);
          } else {
            reject(json);
          }
        }, 375);
      });
    });
}
